import { tr } from '../i18n/i18n';

/**
 * Some dropdown/catalog values (privilege names, school types, plan names, ...)
 * are DB rows seeded in English with no translation key of their own — the
 * raw column value is the only thing the API returns. Slugify it and look up
 * "<namespace>.<slug>", falling back to the raw value for anything not yet
 * in the catalog (e.g. a custom row added after this list was written).
 */
export const slugifyForI18n = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const translateLookupValue = (namespace: string, rawValue: string): string =>
  tr(`${namespace}.${slugifyForI18n(rawValue)}`, rawValue);
